import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';
import VideoWebcamRecorder from './FriendsRecorder';

import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import loading from './../../loading-gif-png-5.gif';

/**
 *  Creates and runs the practice section for Unit3 Module2
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const Friends = (props) => {
  // Initialize variables to be used later
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [recording, setRecording] = useState(false);
  const [takingVideo, setTakingVideo] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [animalTalk, setAnimaTalk] = useState(false);
  const [numVideo, setNumVideo] = useState(0);

  const [numConversation1, setNumConversation1] = useState(0);
  const [displayAudio, setDisplayAudio] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [displayAnimal, setDisplayAnimal] = useState(false);
  const [animateAnimal, setAnimateAnimal] = useState('');
  const [influencerVideo, setInfluencerVideo] = useState('');
  const [playVideo1, setPlayVideo1] = useState('');
  const [playVideo2, setPlayVideo2] = useState('');
  const [videos, setVideos] = useState([]);
  const [displayInfluencer, setDisplayInfluencer] = useState(false);
  const [conversation1, setConversation1] = useState(false);
  const [conversation2, setConversation2] = useState(false);
  const [example, setExample] = useState(true);
  const [animalSize, setAnimalSize] = useState(props.bigAnimal  ? (props.lizard ? 'lizard' : 'bigAnimal') : 'animateAnimal15')
  const [isCommunity, setIsCommunity] = useState(props.conversation === 'COMMUNITY');
  const [audioContext, setAudioContext] = useState(null);
  const [userInteracted, setUserInteracted] = useState(false);
  const [audioError, setAudioError] = useState(false);
  
  // Refs for audio elements
  const mainAudioRef = useRef(null);
  const animalTalkAudioRef = useRef(null);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
  const Exit = generateImageUrl('images/Images/close.png')

  const videoPlayer = {
    minWidth: '100%',
    minHeight: '100%',
    position: 'relative',
  };

  // iOS Audio handling functions
  const initializeAudioContext = () => {
    if (!audioContext && (window.AudioContext || window.webkitAudioContext)) {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      setAudioContext(ctx);
      return ctx;
    }
    return audioContext;
  };

  const enableAudioForIOS = async () => {
    try {
      const ctx = initializeAudioContext();
      if (ctx && ctx.state === 'suspended') {
        await ctx.resume();
      }
      setUserInteracted(true);
      setAudioError(false);
    } catch (error) {
      console.warn('Audio context initialization failed:', error);
      setAudioError(true);
    }
  };

  const playAudioSafely = async (audioElement) => {
    if (!audioElement) return false;
    
    try {
      // Ensure user interaction has occurred
      if (!userInteracted) {
        await enableAudioForIOS();
      }
      
      // Load the audio if not already loaded
      if (audioElement.readyState < 2) {
        await new Promise((resolve, reject) => {
          const onLoad = () => {
            audioElement.removeEventListener('canplaythrough', onLoad);
            audioElement.removeEventListener('error', onError);
            resolve();
          };
          const onError = (e) => {
            audioElement.removeEventListener('canplaythrough', onLoad);
            audioElement.removeEventListener('error', onError);
            reject(e);
          };
          audioElement.addEventListener('canplaythrough', onLoad);
          audioElement.addEventListener('error', onError);
          audioElement.load();
        });
      }
      
      const playPromise = audioElement.play();
      if (playPromise !== undefined) {
        await playPromise;
      }
      return true;
    } catch (error) {
      console.warn('Audio playback failed:', error);
      setAudioError(true);
      return false;
    }
  };

  useEffect(() => {
    if(recording) {
        setupGame();
    }
  }, [numVideo, recording]);

  useEffect(() => {
    if(recording) {
        displayConversation();
    }
  }, [numConversation1]);

  // Handle user interaction for iOS audio
  useEffect(() => {
    const handleUserInteraction = () => {
      if (!userInteracted) {
        enableAudioForIOS();
      }
    };

    // Add event listeners for user interaction
    document.addEventListener('touchstart', handleUserInteraction, { once: true });
    document.addEventListener('click', handleUserInteraction, { once: true });
    document.addEventListener('keydown', handleUserInteraction, { once: true });

    return () => {
      document.removeEventListener('touchstart', handleUserInteraction);
      document.removeEventListener('click', handleUserInteraction);
      document.removeEventListener('keydown', handleUserInteraction);
    };
  }, [userInteracted]);

  // Handle audio playback when displayAudio changes
  useEffect(() => {
    if (displayAudio && mainAudioRef.current) {
      playAudioSafely(mainAudioRef.current);
    }
  }, [displayAudio, userInteracted]);

  // Handle animalTalk audio playback
  useEffect(() => {
    if (animalTalk && animalTalkAudioRef.current) {
      playAudioSafely(animalTalkAudioRef.current);
    }
  }, [animalTalk, userInteracted]);

  async function setupGame() {
    if (numVideo < props.texts.length) {
      setTakingVideo(true);
    } else {
      (async () => {
        dispatch({
          type: `FREEPLAY_SET_${props.level}_${props.conversation}_${props.topic}`,
          payload: 1,
        });
        setAnimalVoice(await getVideo(props.practiceMessageAudio, login));
        await GetUserVideo(`influencers/${props.influencerid}/conversation_affirmation.mp4`).then((data) => {
          setInfluencerVideo(data);
        });
        setAnimateAnimal(props.practiceMessage);
        setDisplayAnimal(true);
        
      })();
    }
  }

  async function displayConversation() {
      setPlayVideo1(videos[numConversation1]);
      setPlayVideo2(videos[numConversation1 + 1]);
      setConversation1(true);
  }

  // The HTML code for the practice
  return (
    <>
      {example && (
        <CloudfrontVideoFormat
          source={props.exampleVideo}
          close={props.setDisplayPractice}
          ended={() => {
            setExample(false);
            setRecording(true);            
          }}
      />)}
      {displayAudio && (
        <audio
          ref={mainAudioRef}
          preload="auto"
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayAudio(false);
            setDisplayAnimal(false);
            if (animateAnimal === props.practiceMessage) {
              setDisplayInfluencer(true);
            } else if (animateAnimal === props.practiceConversation) {
              displayConversation();
            } else if (animateAnimal === props.awesomeJob) {
              props.finish();
            }
          }}
          onError={(e) => {
            console.warn('Main audio playback error:', e);
            setAudioError(true);
            // Fallback: continue without audio
            setAudioReady(false);
            setDisplayAudio(false);
            setDisplayAnimal(false);
            if (animateAnimal === props.practiceMessage) {
              setDisplayInfluencer(true);
            } else if (animateAnimal === props.practiceConversation) {
              displayConversation();
            } else if (animateAnimal === props.awesomeJob) {
              props.finish();
            }
          }}
          onLoadStart={() => {
            setAudioError(false);
          }}
        >
          <source src={animalVoice} type="audio/mpeg"></source>
          <source src={animalVoice} type="audio/wav"></source>
          <source src={animalVoice} type="audio/ogg"></source>
        </audio>
      )}
      {recording && (
        <div
          id='recordpage'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice();
            }}
          ></img>
          {!userInteracted && (
            <div className='step-container-community' style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: 'rgba(0, 0, 0, 0.9)',
              color: 'white',
              padding: '20px',
              borderRadius: '10px',
              textAlign: 'center',
              zIndex: 10000
            }}>
              <div className='step-prompt'>{'Tap to Enable Audio'}</div>
              <div className='step-prompt' style={{ fontSize: '14px', marginTop: '10px' }}>
                {'For the best experience, please tap the button below to enable audio playback.'}
              </div>
              <button 
                className='step-continue' 
                style={{
                  marginTop: '15px',
                  padding: '10px 20px',
                  fontSize: '16px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
                onClick={async () => {
                  await enableAudioForIOS();
                }}
              >
                Enable Audio
              </button>
            </div>
          )}
          {isCommunity && userInteracted && (
            <div className='step-container-community'>
              <div className='step-prompt'>{'Practice Using Good Manners'}</div>
              <div className='step-prompt'>{'Before you practice the conversation remember to use good manners.'}</div>
              <div className='step-prompt'>{'Step 1: How I act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arms length.'}</div>
              <div className='step-prompt'>{'Step 2: What I Say: Use kind words.'}</div>
              <div className='step-prompt'>{'Step 3: How I Say It:  Talk to the community workers in a calm voice.'}</div>
              <button className='step-continue' onClick={() => {
                setIsCommunity(false);
              }}>Continue</button>
            </div>
          )}
          {takingVideo && !isCommunity && userInteracted && (
            <VideoWebcamRecorder
              stepPrompt={props.stepPrompts ? props.stepPrompts[numVideo] : null}
              selectedCharacter={props.turns[numVideo] === 'Your Turn' ? props.selectedStudentCharacter : props.selectedFriendCharacter}
              background={props.background}
              turns={props.turns[numVideo]}
              outputText={props.texts[numVideo]}
              close={props.setDisplayPractice}
              videos={videos}
              setVideos={setVideos}
              title={props.title}
              subTitle={props.subTitle}
              ended={() => {
                setNumVideo(numVideo + 1);
                setTakingVideo(false);
              }}
            />
          )}
          {displayAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
          {displayAnimal && (
            <img
              className={animalSize}
              style={audioReady ? {} : { display: 'none' }}
              onLoad={() => setDisplayAudio(true)}
              src={animateAnimal}
            />
          )}
          {displayInfluencer && (
            <div id='influencerVideo'>
              <video
                style={videoPlayer}
                autoPlay
                onEnded={() => {
                  setAnimalVoice(getVideo(props.practiceConversationAudio, login));
                  setAnimateAnimal(props.practiceConversation);
                  setDisplayAnimal(true);
                  setDisplayInfluencer(false);
                }}
                onError={() => {
                  setAnimalVoice(getVideo(props.practiceConversationAudio, login));
                  setAnimateAnimal(props.practiceConversation);
                  setDisplayAnimal(true);
                  setDisplayInfluencer(false);
                }}
                playsInline
              >
                <source src={influencerVideo} type='video/mp4'></source>
              </video>
            </div>
          )}
          {conversation1 && (
            <div id='border'>
              <video
                id='record-video'
                autoPlay
                onEnded={() => {
                  setConversation1(false);
                  if (numConversation1 > props.texts.length - 1) {
                      setAnimateAnimal(props.awesomeJob);
                      setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                      setDisplayAnimal(true);
                  } else {
                    setConversation2(true);
                  }
                }}
                onError={() => {
                  setConversation1(false);
                  if (numConversation1 > props.texts.length - 1) {
                    setAnimateAnimal(props.awesomeJob);
                    setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                    setDisplayAnimal(true);
                  } else {
                    setConversation2(true);
                  }
                }}
                playsInline
              >
                <source src={playVideo1} type='video/mp4'></source>
              </video>
            </div>
          )}
          {conversation2 && (
            <div id='border'>
              <video
                id='record-video'
                autoPlay
                onEnded={() => {
                  setConversation2(false);
                  if (numConversation1 === props.turns.length - 1) {
                    setAnimateAnimal(props.awesomeJob);
                    setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                    setDisplayAnimal(true);
                  } else {
                    setNumConversation1(numConversation1 + 2);
                  }
                }}
                onError={() => {
                  setConversation2(false);
                  if (numConversation1 === props.turns.length - 1) {
                    setAnimateAnimal(props.awesomeJob);
                    setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                    setDisplayAnimal(true);
                  } else {
                    setNumConversation1(numConversation1 + 2);
                  }
                }}
                playsInline
              >
                <source src={playVideo2} type='video/mp4'></source>
              </video>
            </div>
          )}
        </div>
      )}
      {animalTalk && (
        <audio
          ref={animalTalkAudioRef}
          preload="auto"
          onEnded={() => {
            setAnimaTalk(false);
          }}
          onError={(e) => {
            console.warn('Animal talk audio playback error:', e);
            setAudioError(true);
            // Fallback: continue without audio
            setAnimaTalk(false);
          }}
          onLoadStart={() => {
            setAudioError(false);
          }}
        >
          <source src={animalVoice} type="audio/mpeg"></source>
          <source src={animalVoice} type="audio/wav"></source>
          <source src={animalVoice} type="audio/ogg"></source>
        </audio>
      )}
      {audioError && (
        <div style={{
          position: 'fixed',
          top: '10px',
          right: '10px',
          background: 'rgba(255, 165, 0, 0.9)',
          color: 'white',
          padding: '10px',
          borderRadius: '5px',
          fontSize: '12px',
          zIndex: 9999
        }}>
          Audio unavailable - continuing without sound
        </div>
      )}
    </>
  );
};
export default Friends;
